import React, { useState, useEffect } from 'react';
import { useLanguageData } from '../contexts/LanguageContext';
import './BusinessScenarioModal.css';

const BusinessScenarioModal = ({ isOpen, onClose, onSubmit, language, scenario }) => {
  const languageCodeMap = {
    'german': 'de', 'english': 'en', 'french': 'fr',
    'italian': 'it', 'spanish': 'es', 'japanese': 'ja'
  };

  const initialCode = languageCodeMap[language?.toLowerCase()] || language || 'de';
  const [selectedLanguage, setSelectedLanguage] = useState(initialCode);
  const [dialect, setDialect] = useState('');
  const [selectedAvatar, setSelectedAvatar] = useState('');
  const [isLanguageOpen, setIsLanguageOpen] = useState(false);

  // Reset all modal state when modal opens
  useEffect(() => {
    if (isOpen) {
      const code = language ? (languageCodeMap[language.toLowerCase()] || language) : 'de';
      setSelectedLanguage(code);
      setDialect('');
      setSelectedAvatar('');
      setIsLanguageOpen(false);
    }
  }, [isOpen, language]);

  const { languages: languagesData } = useLanguageData();

  if (!isOpen) return null;

  const languageOptions = Object.entries(languagesData)
    .map(([code, data]) => ({
      value: code,
      label: data.label,
      flag: data.flag || `/images/flag-${code}.svg`,
      active: data.active !== false
    }));

  const currentLanguage = languageOptions.find(l => l.value === selectedLanguage);
  const codeToNameMap = { 'de': 'german', 'en': 'english', 'fr': 'french', 'it': 'italian', 'es': 'spanish', 'ja': 'japanese' };

  const handleSubmit = () => {
    onSubmit({
      language: codeToNameMap[selectedLanguage] || selectedLanguage,
      dialect,
      avatar: selectedAvatar,
      scenario
    });
  };

  return (
    <>
      <div className="bs-modal-overlay"></div>
      <div className="bs-modal">
        <div className="bs-modal-accent-bar"></div>
        <div className="bs-modal-header">
          <h2 className="bs-modal-title">Business Scenario</h2>
        </div>

        <p className="bs-modal-description">
          Apply your language skills in real-world professional situations. Gain confidence to communicate smoothly and succeed in workplace conversations.
        </p>

        <div className="bs-modal-form">
          <div className="bs-modal-field">
            <label className="bs-modal-label"><span className="bs-modal-required">*</span> Language</label>
            <div className="bs-modal-custom-select">
              <div className="bs-modal-select-trigger" onClick={() => setIsLanguageOpen(!isLanguageOpen)}>
                <img src={currentLanguage?.flag} alt={currentLanguage?.label} className="bs-modal-flag" />
                <span className="bs-modal-select-text">{currentLanguage?.label || 'Select Language'}</span>
                <svg className="bs-modal-chevron" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M5 7.5L10 12.5L15 7.5" stroke="#555555" strokeWidth="1.5"/>
                </svg>
              </div>
              {isLanguageOpen && (
                <div className="bs-modal-dropdown">
                  {languageOptions.map(option => (
                    <div key={option.value}
                      className={`bs-modal-dropdown-item ${selectedLanguage === option.value ? 'selected' : ''} ${!option.active ? 'inactive' : ''}`}
                      onClick={() => { if (!option.active) return; setSelectedLanguage(option.value); setIsLanguageOpen(false); }}>
                      <img src={option.flag} alt={option.label} className="bs-modal-flag" />
                      <span>{option.label}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          <div className="bs-modal-field bs-modal-field-disabled">
            <label className="bs-modal-label">Select your AI avatar Dialects <span className="coming-soon-text">Coming Soon<img src="/images/Time.svg" alt="" className="time-icon" /></span></label>
            <div className="bs-modal-select-trigger" style={{ opacity: 0.5, pointerEvents: 'none' }}>
              <select value={dialect} disabled className="bs-modal-native-select">
                <option value="">Select a dialect.</option>
                <option value="standard">Standard</option>
                <option value="regional">Regional</option>
                <option value="formal">Formal</option>
                <option value="informal">Informal</option>
              </select>
              <svg className="bs-modal-chevron" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M5 7.5L10 12.5L15 7.5" stroke="#555555" strokeWidth="1.5"/>
              </svg>
            </div>
          </div>
        </div>

        <div className="bs-modal-avatars">
          <h3 className="bs-modal-avatars-title">Choose AI Avatar!</h3>
          <div className="bs-modal-avatars-grid">
            <div className={`bs-modal-avatar-card ${selectedAvatar === 'Max-business.mp4' ? 'selected' : ''}`}
              onClick={() => setSelectedAvatar('Max-business.mp4')}>
              <img src="/images/MaleAvatar.svg" alt="Soren" className="bs-modal-avatar-image" />
              <div className="bs-modal-avatar-chip">
                <span className={`bs-modal-radio ${selectedAvatar === 'Max-business.mp4' ? 'checked' : ''}`}></span>
                <span className="bs-modal-avatar-name">Soren</span>
              </div>
            </div>
            <div className={`bs-modal-avatar-card ${selectedAvatar === 'talkingavater.mp4' ? 'selected' : ''}`}
              onClick={() => setSelectedAvatar('talkingavater.mp4')}>
              <img src="/images/FemaleAvatar.svg" alt="Nebula" className="bs-modal-avatar-image" />
              <div className="bs-modal-avatar-chip">
                <span className={`bs-modal-radio ${selectedAvatar === 'talkingavater.mp4' ? 'checked' : ''}`}></span>
                <span className="bs-modal-avatar-name">Nebula</span>
              </div>
            </div>
          </div>

        </div>

        <div className="bs-modal-footer">
          <button className="bs-modal-cancel" onClick={onClose}>Cancel</button>
          <button className="bs-modal-submit" onClick={handleSubmit}>Submit</button>
        </div>
      </div>
    </>
  );
};

export default BusinessScenarioModal;
